import * as yup from "yup";
import { IconButton, styled, TextField, useTheme } from "@mui/material";
import { Close, Send } from "@mui/icons-material";
import { useCreateComment } from "../api/createComment";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

const StyledForm = styled("form")(({ theme }) => ({
  width: "100%",
}));

const schema = yup.object().shape({
  text: yup.string().min(15, "Comentário muito pequeno").required(),
});

const defaultValues = {
  text: "",
};

const CreateComment = ({
  postId,
  replyingTo,
  inputRef,
  onSuccess = () => {},
  resetReplyingTo = () => {},
}) => {
  const formMethods = useForm({ resolver: yupResolver(schema), defaultValues });
  const theme = useTheme();
  const createCommentMutation = useCreateComment();
  const handleSubmit = (values) => {
    createCommentMutation.mutate(
      {
        postId,
        text: values.text,
        parentId: replyingTo,
      },
      {
        onSuccess: (data, variables, context) => {
          formMethods.reset();
          onSuccess(data, variables, context);
        },
      }
    );
  };

  const getPlaceHolderText = () => {
    if (Boolean(replyingTo)) {
      return "Responder...";
    } else {
      return "Adicione um comentário...";
    }
  };
  const error = formMethods.formState?.errors?.text?.message;
  console.log(error);
  return (
    <StyledForm onSubmit={formMethods.handleSubmit(handleSubmit)}>
      {!!error && (
        <label className="absolute text-xs left-4 text-red-500">{error}</label>
      )}
      <TextField
        error={!!error}
        sx={{
          width: "100%",
          input: {
            color: "red",
            padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
          },
          ".MuiInputBase-input": {
            paddingLeft: 2,
          },
        }}
        multiline
        inputRef={inputRef}
        InputProps={{
          startAdornment: Boolean(replyingTo) ? (
            <IconButton onClick={resetReplyingTo}>
              <Close />
            </IconButton>
          ) : null,
          endAdornment: (
            <IconButton type="submit">
              <Send />
            </IconButton>
          ),
        }}
        {...formMethods.register("text")}
        variant="standard"
        placeholder={getPlaceHolderText()}
      />
    </StyledForm>
  );
};
export default CreateComment;
